<template>
  <SmartLink v-if="ready" :to="to" :href="href" :nick="nick" :soft="soft" class="responsive-img-container">
    <picture class="d-flex justify-center align-center">
      <source
        v-for="(item, ind) in preloaded.sources"
        :key="ind"
        :srcset="item.srcset"
        :media="item.media"
        :type="item.type"
      />
      <img v-bind="img" />
    </picture>
  </SmartLink>
</template>
<script setup>
const props = defineProps({
  preloaded: { type: Object, default: null },
  alt: { type: String, default: "Offer" },
  to: { type: String, default: "" },
  href: { type: String, default: "" },
  soft: { type: String, default: "" },
  nick: { type: String, default: "" },
});

const style = ref(props?.preloaded?.img?.style || "width:100%;height:auto;");
const img = ref(_.omit(props?.preloaded?.img, ["style"]));
const ready = props.preloaded && (!!props.nick || !!props.soft || !!props.to || !!props.href);
</script>
<style scoped>
.responsive-img-container {
  position: relative;
  width: 100%;
  overflow: hidden;
}

/* Desktop: 1020x370 = 2.76 */
@media (min-width: 1200px) {
  .responsive-img-container::before {
    content: "";
    display: block;
    padding-top: 36.27%; /* 370 / 1020 * 100 */
  }
}

/* Mobile: 430x616 = 0.698 */
@media (max-width: 1199px) {
  .responsive-img-container::before {
    content: "";
    display: block;
    padding-top: 143.26%; /* 616 / 430 * 100 */
  }
}

.responsive-img-container picture,
.responsive-img-container img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
